import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

function Card({ children }) {
  return <div className="cardsList__card">{children}</div>;
}

function Icon({ icon = null }) {
  return (
    <div className="cardsList__icon-bloc">
      <img className="cardsList__icon" src={icon} alt="" />
    </div>
  );
}
Card.Icon = Icon;

function Title({ children }) {
  return <h2 className="cardsList__title">{children}</h2>;
}
Card.Title = Title;

Icon.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};

Icon.defaultProps = {
  icon: null,
};

Title.propTypes = {
  children: PropTypes.node.isRequired,
};

Card.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Card;
